import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-659c0dd4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "grid" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Title*", -1));
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Service*", -1));
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "onedesk-input-label onedesk-input-label-linear" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Color")
], -1));
const _hoisted_8 = { class: "p-inputgroup color-picker-group" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "p-inputgroup-addon" }, "#", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "onedesk-input-label onedesk-input-label-linear" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Upload new icon (Only svg extension is supported)")
], -1));
const _hoisted_11 = { class: "user-save-claims-button-wrapper" };
import { computed, onBeforeMount, ref, } from "vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import ColorPicker from "primevue/colorpicker";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import { updateCatalogCategory, addCatalogCategory, getCatalogCategoryById, } from "@/repositories/catalog-category.repository";
import FileUpload from "primevue/fileupload";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
import { AllActionTypes } from "@/store/action-types";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { useStore } from "@/shared/composables/useStore";
import { mandatoryField, maxLength } from "@/shared/utils/validation";
import useFormValidation from "@/shared/composables/useFormValidation";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpsertCatalogCategory',
    props: {
        categoryId: {}
    },
    emits: ["category-updated"],
    setup(__props, { emit: __emit }) {
        const { categoryId } = __props;
        const notify = useToastNotify();
        const store = useStore();
        const emit = __emit;
        const { validationStateDict, invalidForm } = useFormValidation();
        const selectedCategory = ref({
            title: "",
            serviceId: "",
            backgroundColorHex: "",
            pictureUri: "",
        });
        const blobUrl = ref("");
        const color = ref("20BADC");
        const services = computed(() => store.getters[ReferenceValuesTypes.CATALOGSERVICES]);
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.CATALOGSERVICES);
            await getCategoryById();
        });
        const getCategoryById = async () => {
            if (categoryId) {
                selectedCategory.value = await getCatalogCategoryById(categoryId);
                color.value = selectedCategory.value.backgroundColorHex.substring(1);
            }
        };
        const upload = (event) => {
            if (event.files && event.files[0]) {
                blobUrl.value = event.files[0].objectURL;
                const reader = new FileReader();
                reader.onload = (e) => selectedCategory.value.base64Picture = e.target?.result;
                reader.readAsDataURL(event.files[0]);
            }
        };
        const onClear = () => {
            blobUrl.value = "";
            selectedCategory.value.base64Picture = "";
        };
        const onSave = async () => {
            if (invalidForm.value)
                return;
            await createOrUpdateService();
        };
        const createOrUpdateService = async () => {
            const category = {
                title: selectedCategory.value.title,
                serviceId: selectedCategory.value.serviceId,
                backgroundColorHex: '#' + color.value,
                base64Picture: selectedCategory.value.base64Picture,
            };
            try {
                if (categoryId) {
                    category.id = categoryId;
                    await updateCatalogCategory(category);
                }
                else
                    await addCatalogCategory(category);
                notifyUserAndEmitUpdated(categoryId ? "updated" : "created");
            }
            catch (error) {
                notify("", error.message, "error");
            }
        };
        const notifyUserAndEmitUpdated = (action = "updated") => {
            notify("", `Category : ${selectedCategory.value.title} has been successfully ${action}`, "success");
            emit("category-updated");
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(OneDeskInput, {
                            modelValue: selectedCategory.value.title,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedCategory.value.title) = $event)),
                            class: "wp-pages-inputs",
                            "max-length": 50,
                            rules: [_unref(mandatoryField), _unref(maxLength)(50)],
                            "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).title = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_3
                            ]),
                            _: 1
                        }, 8, ["modelValue", "rules"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(OneDeskDropdown, {
                            modelValue: selectedCategory.value.serviceId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedCategory.value.serviceId) = $event)),
                            options: services.value,
                            class: "wp-pages-inputs",
                            lineraLabel: false,
                            fullWidth: true,
                            optionValue: "id",
                            optionLabel: "label",
                            required: true,
                            "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).serviceId = $event))
                        }, {
                            label: _withCtx(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createVNode(OneDeskInput, {
                                placeholder: "color",
                                modelValue: color.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((color).value = $event)),
                                class: "color-code-picker-input"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(ColorPicker), {
                                modelValue: color.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((color).value = $event)),
                                format: "hex",
                                class: "category-color-picker"
                            }, null, 8, ["modelValue"])
                        ]),
                        _hoisted_10,
                        (selectedCategory.value?.pictureUri)
                            ? (_openBlock(), _createBlock(ImageWithNoImageDefault, {
                                key: 0,
                                class: "mb-3",
                                source: selectedCategory.value?.pictureUri
                            }, null, 8, ["source"]))
                            : _createCommentVNode("", true),
                        _createVNode(_unref(FileUpload), {
                            customUpload: true,
                            onSelect: upload,
                            onClear: onClear,
                            mode: "advanced",
                            accept: ".svg",
                            showCancelButton: true,
                            showUploadButton: false,
                            fileLimit: 1
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createVNode(OneDeskButton, {
                        class: "user-save-claims-button",
                        onClick: onSave,
                        disabled: _unref(invalidForm),
                        icon: "pi pi-save",
                        label: "Save"
                    }, null, 8, ["disabled"])
                ])
            ], 64));
        };
    }
});
